import React        from 'react';
import CarItem          from '../components/CarItem';
import StepsToMoving    from '../components/StepsToMoving';

function getCars(lang) {
    return [
        {
            id: '0001',
            name: 'Lada Largus',
            icon: 'unib',
            photo: '/static/img/carpark/lada_largus@2x.png',
            type: lang.Calculator_FullM,
            bonus: lang.entranceFree,
            tariff: lang.CalculatorMin,
            description: lang.getCarsInfo1,
            params: {
                height: 0.9,
                long: 1.8,
                width: 2,
                volume: 3.2,
                weight: 0.8
            },
            colorBadge: 'green'
        }, {
            id: '0002',
            name: 'Peugeot Partner',
            icon: 'commerc',
            photo: '/static/img/carpark/Peugeot_Expert@2x.png',
            type: lang.Calculator_FullM,
            bonus: lang.entranceFree,
            tariff: lang.CalculatorMin,
            description: lang.getCarsInfo2,
            params: {
                height: 1.2,
                long: 1.8,
                width: 1.2,
                volume: 2.5,
                weight: 0.8
            },
            colorBadge: 'green'
        }, {
            id: '0003',
            name: lang.CalculatorGAZBus,
            icon: 'furgon',
            photo: '/static/img/carpark/GAZelle_Next@2x.png',
            type: lang.Calculator_Furgon,
            bonus: lang.entranceFee,
            tariff: lang.CalculatorStand,
            description: lang.getCarsInfo3,
            params: {
                height: 2,
                long: 3,
                width: 2,
                volume: 12,
                weight: 1.5
            },
            colorBadge: 'orange'
        }, {
            id: '0004',
            name: 'Hyundai Porter',
            icon: 'porter',
            photo: '/static/img/carpark/Hyundai_Porter@2x.png',
            type: lang.Calculator_Furgon,
            bonus: lang.entranceFee,
            tariff: lang.CalculatorStand,
            description: lang.getCarsInfo4,
            params: {
                height: 1.6,
                long: 2.8,
                width: 1.6,
                volume: 7,
                weight: 1
            },
            colorBadge: 'orange'
        }, {
            id: '0005',
            name: 'Fiat Ducato',
            icon: 'vnunib',
            photo: '/static/img/carpark/Fiat_Ducato@2x.png',
            type: lang.Calculator_FullM,
            bonus: lang.entranceFee,
            tariff: lang.CalculatorStand,
            description: lang.getCarsInfo5,
            params: {
                height: 1.8,
                long: 3,
                width: 1.8,
                volume: 9.5,
                weight: 1.5
            },
            colorBadge: 'orange'
        }, {
            id: '0006',
            name: 'Peugeot Boxer',
            icon: 'vnbus',
            photo: '/static/img/carpark/Peugeot_Expert@2x.png',
            type: lang.Calculator_FullM,
            bonus: lang.entranceFee,
            tariff: lang.CalculatorStand,
            description: lang.getCarsInfo6,
            params: {
                height: 1.9,
                long: 3,
                width: 1.8,
                volume: 10,
                weight: 1.5
            },
            colorBadge: 'orange'
        }, {
            id: '0007',
            name: 'GAZelle Бизнес',
            icon: 'furgon',
            photo: '/static/img/carpark/GAZelle_Next@2x.png',
            type: lang.Calculator_Furgon,
            bonus: lang.entranceFee,
            tariff: lang.CalculatorExtra,
            description: lang.getCarsInfo7,
            params: {
                height: 2,
                long: 4,
                width: 2,
                volume: 16,
                weight: 1.5
            },
            colorBadge: 'orange'
        }, {
            id: '0008',
            name: 'GAZelle Next',
            icon: 'gnext',
            photo: '/static/img/carpark/GAZelle_Next@2x.png',
            type: lang.Calculator_Furgon,
            bonus: lang.entranceFee,
            tariff: lang.CalculatorExtra,
            description: lang.getCarsInfo8,
            params: {
                height: 2,
                long: 4.2,
                width: 2,
                volume: 17,
                weight: 1.5
            },
            colorBadge: 'orange'
        }, {
            id: '0009',
            name: 'Ford Transit',
            icon: 'tent',
            photo: '/static/img/carpark/ford_transit@2x.png',
            type: lang.Calculator_FullM,
            bonus: lang.entranceFee,
            tariff: lang.CalculatorExtra,
            description: lang.getCarsInfo9,
            params: {
                height: 2,
                long: 4,
                width: 2,
                volume: 16,
                weight: 1.5
            },
            colorBadge: 'orange'
        }, {
            id: '0010',
            name: 'Foton',
            icon: 'box',
            photo: '/static/img/carpark/mercedes_sprinter@2x.png',
            type: lang.Calculator_Furgon,
            bonus: lang.entranceFee,
            tariff: lang.CalculatorMax,
            description: lang.getCarsInfo10,
            params: {
                height: 2.1,
                long: 4.5,
                width: 2.1,
                volume: 20,
                weight: 3
            },
            colorBadge: 'orange'
        }, {
            id: '0011',
            name: 'JMC',
            icon: 'box',
            photo: '/static/img/carpark/mercedes_sprinter@2x.png',
            type: lang.Calculator_Furgon,
            bonus: lang.entranceFee,
            tariff: lang.CalculatorMax,
            description: lang.getCarsInfo11,
            params: {
                height: 2,
                long: 4.2,
                width: 2,
                volume: 17,
                weight: 3
            },
            colorBadge: 'orange'
        },
    ]
}

export default class CarPark extends React.Component {

    constructor(props) {
        super(props);
        this.state = {};

        this.CARPARK = getCars(props.lang);
    }

    componentWillReceiveProps(newProps) {
        this.CARPARK = getCars(newProps.lang);
    }

    render() {

        const { lang } = this.props;

        return (
            <div key="Carpark" className="page carpark">
                {this.CARPARK.map(item => <CarItem lang={lang} key={item.id} info={item} />)}

                <StepsToMoving lang={lang} />
            </div>
        );
    }
}